<template>
  <div id="treemap">
    <svg id="canvas" :width="width" :height="height">
      <g class="children" v-for="child in leaves" :key="'c_' + child.id" @click="clicked_g(child)">
        <rect
          class="child tooltip"
          :id="child.id"
          :key="child.id"
          :height="y(child.y1) - y(child.y0)"
          :width="x(child.x1) - x(child.x0)"
          :x="x(child.x0)"
          :y="y(child.y0)"
          :style="{ fill: child.color  }"
        ></rect>
        <title>{{ child.data.name }} - {{child.data.real_value}}</title>

        <foreignObject
          :key="'fObj2_' + child.id"
          :x="x(child.x0) + 6"
          :y="y(child.y0) + 6"
          :width="x(child.x1) - x(child.x0) - 6"
          :height="y(child.y1) - y(child.y0) - 6"
        >
          <p xmlns="http://www.w3.org/1999/xhtml">{{ child.data.name }}</p>
        </foreignObject>

        <!-- The visible square text element with the title and value of the child node -->
        <switch>
          <foreignObject
            :key="'fObj_' + child.id"
            :x="x(child.x0) + 6"
            :y="y(child.y0) + 6"
            :width="x(child.x1) - x(child.x0) - 6"
            :height="y(child.y1) - y(child.y0) - 6"
          >
            <p xmlns="http://www.w3.org/1999/xhtml">{{ child.data.name }}</p>
          </foreignObject>

          <text
            :key="'t_' + child.id"
            :x="x(child.x0) + 6"
            :y="y(child.y0) + 6"
            :width="x(child.x1) - x(child.x0) - 6"
            :height="y(child.y1) - y(child.y0) - 6"
            style="fill-opacity: 1;"
          >{{ child.data.name }}</text>
        </switch>
      </g>
    </svg>
  </div>
</template>
<script>
/* eslint-disable */
let d3 = require("d3");
let color = d3.scaleOrdinal().range(d3.schemeCategory10);
let format = d3.format(",d");

export default {
  name: "Treemap",
  data() {
    return {
      width: 920,
      height: 530,
      padding: 1,
      margin: {
        top: 20,
        right: 0,
        bottom: 0,
        left: 0
      },
      rootNode: {},
      leaves: null,
      colorMap: {
        Indivíduo: "#00C7F4",
        Mundo: "#39DF18",
        Sociedade: "#FFA300"
      }
    };
  },
  props: {
    raw_data: {},
    tree_data: {}
  },
  computed: {
    // Returns the x position within the current domain
    // Maybe it can be replaced by a vuejs method
    x() {
      return d3
        .scaleLinear()
        .domain([0, this.width])
        .range([0, this.width]);
    },
    // Returns the y position within the current domain
    // Maybe it can be replaced by a vuejs method
    y() {
      return d3
        .scaleLinear()
        .domain([0, this.height - this.margin.top - this.margin.bottom])
        .range([0, this.height - this.margin.top - this.margin.bottom]);
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    clicked_g(child) {
      console.log("g in da house", child);
    },
    initialize() {
      let that = this;
      let treemap = data =>
        d3
          .treemap()
          .size([this.width, this.height])
          .padding(this.padding)
          .round(false)(
          d3
            .hierarchy(data)
            .eachBefore(function(d) {
              d.my_id = d.data.id;
              d.id = (d.parent ? d.parent.id + "." : "") + d.data.name;
              if (d.depth >= 1) {
                d.color =
                  d.depth == 1 ? that.colorMap[d.data.name] : d.parent.color;
              }
            })
            .sum(d => d.value)
            .sort((a, b) => b.height - a.height || b.value - a.value)
        );

      const root = treemap(this.tree_data);
      this.rootNode = root;
      console.log('tree_data', this.tree_data)
      this.leaves = root.leaves();
      console.log('leaves', this.leaves)
    }
  }
};
</script>
<style lang="scss" scoped>
p {
  text-overflow: clip;
  overflow: hidden;
  height: 100%;
  font-weight: 300;
  line-height: 1.3;
  font-size: 12px;
  text-align: center;
  margin-left: 0px;
  padding-right: 5px;
}
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>




// WEBPACK FOOTER //
// src/components/reusable/TreeMap.vue